export const SSN_MASK = '99.99.99-999.99';
export const VAT_MASK = ' 0000.000.000';

export const IBAN_MASK = 'aa99 **** **** ***?* **** **** **** **** **';
